import React, { lazy } from "react"
import { Common } from "lib/types"
import { ReactComponent as CustomerIcon } from "images/icons/users.svg"
import { PermissionGroups } from "../constants"

const Customer = lazy(() => import("views/Customer/Customer").then(m => ({ default: m.Customer })))
const SearchCustomer = lazy(() => import("views/Customer/SearchCustomer"))

export const customerRoutes: Common.Views = [
  {
    element: <Customer />,
    path: "/customer",
    title: "Customer",
    icon: CustomerIcon,
    sortOrder: 5,
    requiredGroups: PermissionGroups.customers.read,
    children: [
      {
        element: <SearchCustomer />,
        path: "/customer",
        title: "Store groups"
      }
    ]
  }
]
